"use client";

import React, { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Star, ChevronDown, ChevronUp, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
interface ReviewItem {
  id: number;
  name: string;
  company: string;
  review: string;
  previewText?: string;
  isLong?: boolean;
}
const reviewsData: ReviewItem[] = [{
  id: 1,
  name: "JPA Roofing",
  company: "JPA Roofing",
  review: "We use BMF as our chosen scaffolding firm for all of our roofing projects. Pete handles everything incredibly professionally, the team are flexible around our projects when they can be, and the office deal with all of the permit and licence administration when required. Communication and responsiveness is friendly and fast. We can not recommend them more."
}, {
  id: 2,
  name: "Structa Roofing Ltd",
  company: "Structa Roofing Ltd",
  review: "Pete and all of the team at BMF are world class! We will only ever use BMF for our scaffolding needs, polite, friendly and extremely helpful. Highly recommend."
}, {
  id: 3,
  name: "Scott Horn",
  company: "",
  previewText: "We engaged BMF to provide the scaffolding for a substantial roof replacement at our property. From the initial consultation through to dismantling, the entire process was handled with an exceptional level of professionalism and efficiency.",
  review: "We engaged BMF to provide the scaffolding for a substantial roof replacement at our property. From the initial consultation through to dismantling, the entire process was handled with an exceptional level of professionalism and efficiency. As the property is a listed building in central London, we were understandably particular about both the standard of workmanship and the care taken with the exterior. Peter was excellent throughout — knowledgeable, courteous and very clear in explaining the proposed works and timescales. The scaffolding was erected and subsequently removed by his team with remarkable efficiency, whilst taking considerable care to ensure the fabric and exterior of the building were protected throughout. The attention to detail was particularly appreciated. BMF delivered precisely what was promised, when it was promised, and to a very high standard. We would have absolutely no hesitation in recommending them and will certainly use them again.",
  isLong: true
}, {
  id: 4,
  name: "Dayo Oshitola",
  company: "",
  previewText: "Excellent service from BMF Scaffolding. I used BMF Scaffolding for my loft extension and couldn't be happier with the service they provided. From start to finish, they were professional, reliable and very easy to deal with.",
  review: "Excellent service from BMF Scaffolding. I used BMF Scaffolding for my loft extension and couldn't be happier with the service they provided. From start to finish, they were professional, reliable and very easy to deal with. They were excellent with timings and always turned up when they said they would, which made a big difference when coordinating the different stages of the build. Health and safety was clearly a priority, and the scaffolding was erected and managed to a very high standard. Communication was also great throughout, with any questions or requirements dealt with quickly and professionally. On top of all that, their pricing was very competitive. I would have no hesitation in recommending BMF Scaffolding to anyone looking for a reliable, professional and competitively priced scaffolding company. Great job from start to finish!",
  isLong: true
}, {
  id: 5,
  name: "Carl Barrie",
  company: "",
  review: "I have used BMF Scaffolding twice now. Once on a new build project and once on an existing home. They were reliable and turned up when agreed. I wouldn't hesitate to recommend them to anyone."
}, {
  id: 6,
  name: "Norik Grigorian",
  company: "",
  review: "Used BMF scaffolding for a few years now has never let me down always on time and nothing's ever a fuss. They just get on and do the job an excellent service from BMF scaffolding."
}, {
  id: 7,
  name: "Aaron Liversidge",
  company: "",
  review: "Have used Pete and his team for years now, have always been very fair in price and very knowledgeable. Would highly recommend 10/10 service."
}, {
  id: 8,
  name: "Aaran Moore",
  company: "",
  review: "Pete and the team were extremely professional very competitively priced and I was absolutely delighted with the care taken when doing the work and the communication throughout."
}, {
  id: 9,
  name: "Jen Ralphs",
  company: "",
  review: "We used Pete and his team for our house renovation scaffolding. He was incredibly easy to deal with, the team were brilliant - and even child friendly when the little ones wanted to chat and see what was going on! I continue to recommended this team to anyone in need of scaffolding! 10/10."
}, {
  id: 10,
  name: "Andrew Grover",
  company: "",
  review: "We have used Pete on numerous occasion, he's never let us down and I would not hesitate to use him on future projects"
}, {
  id: 11,
  name: "Simon Baker",
  company: "",
  review: "The job was done on time and to the exact specifications required Very professional outfit indeed.....highly recommend"
}, {
  id: 12,
  name: "Lee Jones",
  company: "",
  review: "Had several scaffolds erected by bmf scaffolding. There team were polite, efficient and on time. Amazing professional service. Best scaffolders around"
}, {
  id: 13,
  name: "Nick Pratt",
  company: "",
  review: "Highly recommend!! always a great service with these guys!!!! The team are professional, reliable, and competitively priced."
}, {
  id: 14,
  name: "Teresa Baker",
  company: "",
  review: "Great group of hard working lads the owner really new what we needed great company defo use again in the future quick turn over time."
}, {
  id: 15,
  name: "Regan Senior",
  company: "",
  review: "10/10 service, always fair prices and there on time"
}, {
  id: 16,
  name: "Thomas Butler",
  company: "",
  review: "Great service !"
}];
function ReviewCard({
  review,
  index
}: {
  review: ReviewItem;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div data-index={index} className="h-full">
      <Card className="h-full flex flex-col justify-between border border-border bg-card shadow-sm hover:shadow-md hover:border-primary/50 transition-[border-color,box-shadow] duration-200">
        <CardHeader className="space-y-3 pb-2">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-1" aria-label="5 out of 5 stars">
              {[0, 1, 2, 3, 4].map(starIndex => <Star key={starIndex} data-index={starIndex} className="size-4 text-chart-5 fill-chart-5" aria-hidden="true" />)}
            </div>
            <Badge variant="outline" className="bg-muted/50 text-muted-foreground border-border text-[11px] font-medium tracking-normal px-2 py-0.5">
              Google Review
            </Badge>
          </div>
        </CardHeader>

        <CardContent className="flex-1 text-sm leading-relaxed text-card-foreground">
          {review.isLong ? <Collapsible open={isOpen} onOpenChange={setIsOpen}>
              <p className="text-card-foreground">
                {isOpen ? review.review : review.previewText}
              </p>
              <CollapsibleContent>
                {/* Content displayed when open */}
              </CollapsibleContent>
              <CollapsibleTrigger asChild>
                <Button variant="ghost" size="sm" className="mt-2 h-7 px-0 font-medium text-primary hover:text-primary/80 hover:bg-transparent">
                  <span>{isOpen ? "Show less" : "Read full review"}</span>
                  {isOpen ? <ChevronUp className="size-3.5" /> : <ChevronDown className="size-3.5" />}
                </Button>
              </CollapsibleTrigger>
            </Collapsible> : <p className="text-card-foreground">{review.review}</p>}
        </CardContent>

        <CardFooter className="pt-4 border-t border-border/70 flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="font-semibold text-foreground text-sm tracking-tight truncate">
              {review.name}
            </p>
            {review.company ? <p className="text-xs text-primary font-medium truncate">
                {review.company}
              </p> : null}
          </div>
          <div className="flex items-center text-xs text-muted-foreground gap-1 shrink-0">
            <CheckCircle2 className="size-3.5 text-primary" aria-hidden="true" />
            <span className="text-[11px]">Verified</span>
          </div>
        </CardFooter>
      </Card>
    </div>;
}
export default function CustomerReviews() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.06
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0,
      y: shouldReduceMotion ? 0 : 18
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.45,
        ease: "easeOut"
      }
    }
  };
  return <section id="customerreviews" data-nav="light" className="bg-background py-16 sm:py-20 lg:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mb-12 sm:mb-16">
          <div className="flex items-center gap-2 mb-3">
            <span className="h-0.5 w-6 bg-primary inline-block" aria-hidden="true" />
            <span className="text-xs font-semibold uppercase tracking-wider text-primary">
              Client Feedback
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground">
            What our customers say
          </h2>
          <p className="mt-3 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Real feedback from homeowners, contractors and businesses who have worked with BMF Scaffolding.
          </p>
        </div>

        {/* 16 Reviews Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.05
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviewsData.map((reviewItem, idx) => <motion.div key={reviewItem.id} variants={itemVariants} className="h-full">
              <ReviewCard review={reviewItem} index={idx} />
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}